import Flex from 'components/Flex'
import React from 'react'
import styled from 'styled-components'

const Wrapper = styled(Flex)`
  column-gap: 10px;
`

const TagContainer = styled(Flex)`
  width: 34;
  height: 24px;
  background: #f2f3f5;
  border-radius: 6px;
  padding: 3px 8px;
  color: #676e83;
  font-weight: 600;
  font-size: 14px;
  text-transform: capitalize;
`

const Tags = ({ tagsData = [] }) => {
  if (tagsData.length === 0) {
    return null
  }

  return (
    <Wrapper>
      <TagContainer centerVertically center>
        +{tagsData.length}
      </TagContainer>
    </Wrapper>
  )
}

export default Tags
